import script from "./UploadSingleImageUser.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSingleImageUser.vue?vue&type=script&setup=true&lang=js"

import "./UploadSingleImageUser.vue?vue&type=style&index=0&id=1b7e6364&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7e6364"]])

export default __exports__